export default __webpack_public_path__ + "../staticImages/sprite-sepa-2x.png";